export const SLIDER_LIST_REQUEST="SLIDER_LIST_REQUEST"
export const SLIDER_LIST_SUCCESS="SLIDER_LIST_SUCCESS"
export const SLIDER_LIST_FAIL="SLIDER_LIST_FAIL"
export const SLIDER_CLEAR="SLIDER_CLEAR"

export const SLIDER_DELETE_REQUEST="SLIDER_DELETE_REQUEST"
export const SLIDER_DELETE_SUCCESS="SLIDER_DELETE_SUCCESS"
export const SLIDER_DELETE_FAIL="SLIDER_DELETE_FAIL"

export const SLIDER_ADD_REQUEST="SLIDER_ADD_REQUEST"
export const SLIDER_ADD_SUCCESS="SLIDER_ADD_SUCCESS"
export const SLIDER_ADD_FAIL="SLIDER_ADD_FAIL"

export const SLIDER_EDIT_REQUEST="SLIDER_EDIT_REQUEST"
export const SLIDER_EDIT_SUCCESS="SLIDER_EDIT_SUCCESS"
export const SLIDER_EDIT_FAIL="SLIDER_EDIT_FAIL"
export const SLIDER_EDIT_RESET="SLIDER_EDIT_RESET"

export const SLIDER_UPDATE_REQUEST="SLIDER_UPDATE_REQUEST"
export const SLIDER_UPDATE_SUCCESS="SLIDER_UPDATE_SUCCESS"
export const SLIDER_UPDATE_FAIL="SLIDER_UPDATE_FAIL"
export const SLIDER_UPDATE_RESET="SLIDER_UPDATE_RESET"